$(function () {
  // const baseUrl = window.location.origin + '/invicta/durasteel/';
  const baseUrl = window.location.origin + '/';
  const toggle = $('.specToggle');
  const next = $('.systemSpec-actions-next');
  const previous = $('.systemSpec-actions-previous');
  const question = $('.systemSpec-questions-block');
  const questionAmount = question.length;
  const progress = $('.systemSpec-progress span');
  const loading = $('.systemSpec-loading');
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  if (urlParams.has('reference')) {
    sessionStorage.setItem('slideoutref', urlParams.get('reference'));
  }
  let active = $('.systemSpec-questions-block.active');
  let index = 1;

  toggle.on('click', function(){
    $('.systemSpec').toggleClass('active');
  });

  next.on('click', function () {
    index++;
    if(index == question.length){
      active.removeClass('active').next(question).addClass('active');
      next.text('Get Results');
    }else if (index <= question.length) {
      active.removeClass('active').next(question).addClass('active');
    } else if(index > question.length) {
      getResults();
    }
    previous.show();
    active = $('.systemSpec-questions-block.active');
    progressChange();
  });
  previous.on('click', function () {
    index--;
    if(index == 1){
      active.removeClass('active').prev(question).addClass('active');
      previous.hide();
    }else if (index >= 1) {
      active.removeClass('active').prev(question).addClass('active');
    } else {
      index = 1;
      previous.hide();
    }
    next.text('Next Question');
    active = $('.systemSpec-questions-block.active');
    progressChange();
  });


  function progressChange() {
    progress.css({
      'width': ''+(100 / questionAmount) * (active.index() + 1) +'%',
    });
  }

  function getResults(){
    let checkboxes = $('.systemSpec input[type="radio"]:checked');
    let keywords = [];
    loading.addClass('visible');
    checkboxes.each(function(){
      keywords.push($(this).val());
    });

    let reference = sessionStorage.getItem('slideoutref'),
        refno;


    if (reference) {
      console.log('ref', reference);
      refno = '&reference=' + reference;
    } else {
      refno = '';
      console.log('noref');
    }

    let url = baseUrl + '/specup-results?keywords=' + keywords.join('+') + refno;

    $('.systemSpec a.redirect').attr('href', url);
    window.location.href = url;
  }


});



// WEBPACK FOOTER //
// ./scripts/components/systemSpec.js